import React from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from '../../components/PageHeader.jsx';
import { SECTION_COLOR } from '../../icons.jsx';
import { findControlItem } from '../../controlItems.jsx';

export default function ControlPlaceholder() {
  const { slug } = useParams();
  const item = findControlItem(slug);

  if (!item) {
    return <div className="empty">Page not found.</div>;
  }

  return (
    <div>
      <PageHeader icon={item.icon} title={item.label} subtitle={item.section} color={SECTION_COLOR.control} />
      <div className="empty">No {item.label.toLowerCase()} yet.</div>
    </div>
  );
}
